import { makeStyles } from '@material-ui/core/styles';
import { condensedStyles } from 'core/components/theme/condensed-layout';

const styles = (theme) => ({
  cardContainer: {
    width: 720,
    ...condensedStyles(theme, { width: '100%', maxWidth: 720 }),
    margin: '0 auto',
    padding: 32
  },
  content: {
    padding: 40
  },
  formWithPadding: {
    marginLeft: 10
  },
  breakUpESignature: {
    marginLeft: -4,
    padding: '25px 0 0'
  },
  cancelPriorInsuranceLine: {
    borderTop: `1px solid ${theme.colorPalette.beige_50_op_70}`,
    padding: '25px 0'
  },
  priorInsuranceFields: {
    marginLeft: 25
  }
});

export default makeStyles(styles);
